import ReactOnRails from 'react-on-rails';
import SignupRoot from '../bundles/Membership/SignupRoot';
import MembershipVideoModal from '../bundles/MembershipVideoModal';

try {
  ReactOnRails.register({ SignupRoot, MembershipVideoModal });
} catch (err) {
  window.Sentry.captureException(err, { extra: { component: 'membership bundle' }});
}
